import { showDjangoMessages } from '@dashboard/entry/utils/django-messages.js';
import { setupPowerMenu } from '@dashboard/entry/utils/power-menu.js';
import { showToast } from '@dashboard/entry/utils/toast.js';

window.showToast = showToast;
window.showDjangoMessages = showDjangoMessages;
setupPowerMenu();
